import { FormControl, TextField } from '@mui/material';
import type { WidgetProps } from 'app/schema-form/types';
import type React from 'react';
import type { ChangeEventHandler } from 'react';
import { useWidgetTitle } from '../../../../schema-form/util/widget.js';
import FieldInfo from '../../field-info/index.js';
import Widget from '../widget.js';

export type NumberOwnProps = WidgetProps & {
  readonly size?: 'small' | 'medium';
};

export type NumberContainerProps = {
  readonly handleChange: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
};

export type NumberProps = NumberOwnProps & NumberContainerProps;

export const Number: React.FC<NumberProps> = (props) => {
  const { schema, config, value, error, isRequired, disabled, readOnly, formName, path, handleChange, size } = props;
  const title = useWidgetTitle(props);
  const isInteger = schema.get('type') === 'integer';

  return (
    <Widget>
      <FormControl fullWidth variant="outlined" error={Boolean(error)}>
        <TextField
          size={size ?? 'small'}
          inputProps={{
            type: 'text',
            inputMode: isInteger ? 'numeric' : 'text',
            step: schema.get('multipleOf'),
            min: schema.get('minimum'),
            max: schema.get('maximum'),
            'data-testid': `${formName}-${path}`
          }}
          label={title}
          value={value}
          error={Boolean(error)}
          disabled={Boolean(disabled) || Boolean(readOnly)}
          required={isRequired}
          onChange={handleChange}
        />
        <FieldInfo description={schema?.get('description')} instructions={config?.get('instructions')} error={error} />
      </FormControl>
    </Widget>
  );
};
